import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3cfd1078"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "game-info" }
const _hoisted_2 = { class: "move-list" }



type Props = {
  turn: number;
  moveHistory: string[];
  isAttackersTurn: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'GameInfoView',
  props: {
    turn: null,
    moveHistory: null,
    isAttackersTurn: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, { class: "info-card" }, {
      default: _withCtx(() => [
        _createElementVNode("p", null, "Turn " + _toDisplayString(__props.turn), 1),
        _createElementVNode("p", null, _toDisplayString(__props.isAttackersTurn ? "Attackers" : "Defenders") + " turn", 1),
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, {
              dense: "",
              justify: "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, { class: "column-header" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Att.")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { class: "column-header" }, {
                  default: _withCtx(() => [
                    _createTextVNode("Def.")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Math.ceil(__props.moveHistory.length / 2), (i) => {
                return (_openBlock(), _createBlock(_component_v_row, {
                  key: i,
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (n) => {
                      return _createVNode(_component_v_col, {
                        key: `${i} ${n}`,
                        class: "column"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_text, { class: "move-card" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(__props.moveHistory.at((i - 1) * 2 + n - 1)), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    }), 64))
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})